// extracted by mini-css-extract-plugin
module.exports = {"container":"TeamAccept_container__Xwuo4"};